export const formatDecimalNumbers = (stringNumber) => {
    const number = parseFloat(stringNumber);
    if (!isNaN(number) && number % 1 !== 0) {
      return number.toFixed(2);
    }
    return stringNumber;
  }